module.exports = __webpack_public_path__ + "img/hot_icon.ee6bb6be.gif";